import React, { useState } from 'react';
import { authService } from '../services/auth';

export default function Login({ onAuthSuccess }) {
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.login(email.trim(), token.trim());
      if (result.success) {
        onAuthSuccess(result.masterId);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Ошибка соединения');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h2 style={styles.title}>Биржа заявок</h2>
        
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />
        
        <input
          type="text"
          placeholder="Одноразовый токен"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          style={styles.input}
          required
        />
        
        {error && <div style={styles.error}>{error}</div>}
        
        <button type="submit" disabled={loading} style={styles.button}>
          {loading ? 'Проверка...' : 'Войти'}
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f5f5f5',
    padding: '16px'
  },
  form: {
    background: '#fff',
    padding: '32px',
    borderRadius: '8px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px'
  },
  title: {
    margin: '0 0 24px 0',
    fontSize: '24px',
    color: '#333',
    textAlign: 'center'
  },
  input: {
    width: '100%',
    padding: '14px',
    margin: '8px 0 16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    boxSizing: 'border-box',
    fontSize: '16px',
    minHeight: '48px'
  },
  button: {
    width: '100%',
    padding: '14px',
    background: '#0073aa',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    minHeight: '48px',
    marginTop: '8px'
  },
  error: {
    color: '#dc3545',
    margin: '8px 0 16px',
    fontSize: '14px',
    padding: '12px',
    background: '#fee',
    borderRadius: '4px'
  }
};